// Password → wrapping key with Argon2id (hash-wasm). Parameters are stored in
// user_keys.kdf so they can be raised later without breaking old wraps.
import { argon2id } from 'hash-wasm';
import { b64url, fromB64url, randomBytes, buf } from './encoding';

export interface KdfParams { alg: 'argon2id'; salt: string; m: number; t: number; p: number }

export function newKdfParams(): KdfParams {
  // 64 MiB, 3 passes: ~1s on a low-end Android phone, acceptable at sign-in.
  return { alg: 'argon2id', salt: b64url(randomBytes(16)), m: 65536, t: 3, p: 1 };
}

export async function deriveWrappingKey(password: string, params: KdfParams): Promise<CryptoKey> {
  const raw = await argon2id({
    password,
    salt: fromB64url(params.salt),
    iterations: params.t,
    parallelism: params.p,
    memorySize: params.m,
    hashLength: 32,
    outputType: 'binary',
  });
  return crypto.subtle.importKey('raw', buf(raw), { name: 'AES-GCM' }, false, ['wrapKey', 'unwrapKey', 'encrypt', 'decrypt']);
}
